import InputLabel from '@material-ui/core/InputLabel';
import { default as MaterialUISelect } from '@material-ui/core/Select/Select';
import React, { ReactElement, ReactNode } from 'react';
import { isMobile } from 'react-device-detect';
import styled from 'styled-components';
import { Select, SelectFieldProps } from '~common/components/select.component';
import { selectOptionsDesktop, selectOptionsMobile } from '~common/components/select.helper';
//TODO: Move this icon to common module
import { CaretIcon } from '~web/view/components/ui/icon/caret.icon';

export const ThemedSelect = (props: Omit<SelectFieldProps, 'renderField'>): ReactElement => {
  const { input, label, options, meta, ...rest } = props;
  const renderField = (): ReactNode => {
    return (
      <>
        <Label htmlFor={input.name}>{label}</Label>
        <StyledSelect
          MenuProps={{
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'left',
            },
            transformOrigin: {
              vertical: 'top',
              horizontal: 'left',
            },
            getContentAnchorEl: null,
            MenuListProps: { style: { maxHeight: '500px' } },
          }}
          SelectDisplayProps={{
            style: {
              fontWeight: 'bold',
              fontSize: '18px',
              background: 'none',
            },
          }}
          IconComponent={(): ReactElement => <StyledCaretIcon />}
          name={input.name}
          inputProps={input}
          value={input.value}
          native={isMobile}
          classes={{ select: 'select' }}
          {...rest}
        >
          {isMobile ? selectOptionsMobile(options) : selectOptionsDesktop(options, input)}
        </StyledSelect>
      </>
    );
  };
  return (
    <Select
      renderField={renderField}
      input={input}
      options={options}
      meta={meta}
      label={label}
      {...rest}
    />
  );
};

const StyledSelect = styled(MaterialUISelect)`
  && {
    height: 34px;
  }
  && .select {
    font-weight: bold;
    font-size: 18px;
  }
  && .select:focus {
    background-color: transparent;
  }
  && .select svg {
    display: none;
  }
`;

const Label = styled(InputLabel)`
  && {
    font-weight: bold;
    font-size: 16px;
    letter-spacing: 0.8px;
    text-transform: uppercase;
  }
`;

const StyledCaretIcon = styled(CaretIcon)`
  && {
    position: absolute;
    right: 0;
    pointer-events: none;
  }
`;



// WEBPACK FOOTER //
// /codebuild/output/src332225586/src/modules/common/src/components/themed-select.component.tsx